export default __webpack_public_path__ + "static/media/13.db6225fe.jpg";